export default "__VITE_ASSET__CSnVXadv__"